import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICON_TYPE } from "utils/constants";
import { InputTypes } from "types/enum";

export const InputAvailable = [
  {
    typeName: "text",
    icon: ["fas", "font"],
    type: InputTypes.text,
    backendType: "string",
    canUseInGrid: true,
  },
  {
    typeName: "textArea",
    icon: ["fas", "align-justify"],
    type: InputTypes.text,
    backendType: "string",
    canUseInGrid: true,
  },
  {
    typeName: "number",
    icon: ["fas", "hashtag"],
    type: InputTypes.number,
    backendType: "int",
    canUseInGrid: true,
  },
  {
    typeName: "decimalNumber",
    icon: ["fas", "hashtag"],
    type: InputTypes.number,
    backendType: "decimal",
    canUseInGrid: true,
  },
  {
    typeName: "SystemNumber",
    icon: ["fas", "hashtag"],
    type: InputTypes.number,
    backendType: "long",
    canUseInGrid: false,
  },
  {
    typeName: "price",
    icon: ["fas", "money-bill"],
    type: InputTypes.price,
    backendType: "decimal",
    canUseInGrid: true,
  },

  {
    typeName: "date",
    icon: ["fas", "calendar-days"],
    type: InputTypes.date,
    backendType: "datetime",
    canUseInGrid: true,
  },
  {
    typeName: "timeLength",
    icon: ["fas", "stopwatch"],
    type: InputTypes.timeLength,
    backendType: "int",
    canUseInGrid: true,
  },
  {
    typeName: "time",
    icon: ["fas", "clock"],
    type: InputTypes.time,
    backendType: "datetime",
    canUseInGrid: true,
  },
  {
    typeName: "selectBox",
    icon: ["fas", "square-caret-down"],
    type: InputTypes.dropDown,
    backendType: "string",
    canUseInGrid: true,
  },
  {
    typeName: "PositionDictionary",
    icon: ["fas", "user"],
    type: InputTypes.PositionDictionary,
    backendType: "guid",
    canUseInGrid: false,
  },
  {
    typeName: "activityStatus",
    icon: ["fa", "fa-toggle-on"],
    type: InputTypes.activityStatus,
    backendType: "string",
    canUseInGrid: false,
  },
  {
    typeName: "url",
    icon: ["fa", "fa-sitemap"],
    type: InputTypes.url,
    backendType: "string",
    canUseInGrid: false,
  },
    {
    typeName: "apiRequestConfigurator",
    icon: ["fa", "fa-sitemap"],
    type: InputTypes.apiRequestConfigurator,
    backendType: "string",
    canUseInGrid: false,
  },
  {
    typeName: "RadioButton",
    icon: ["fas", "circle-dot"],
    type: InputTypes.RadioButton,
    backendType: "string",
    canUseInGrid: true,
  },
  {
    typeName: "checkBox",
    icon: ["fas", "square-check"],
    type: InputTypes.checkBox,
    backendType: "bit",
    canUseInGrid: true,
  },
  // {
  //     typeName:'fileUpload',
  //     icon:"file-arrow-up",
  //     type:InputTypes.fileUpdate,
  //     backendType:"string",
  // },
  {
    typeName: "ProgressBar",
    icon: ["fas", "sliders"],
    type: InputTypes.ProgressBar,
    backendType: "int",
    canUseInGrid: false,
  },
  {
    typeName: "Message",
    icon: ["fas", "info-circle"],
    type: InputTypes.Message,
    backendType: "",
    canUseInGrid: false,
  },
  {
    typeName: "button",
    icon: ["far", "fa-square"],
    type: InputTypes.button,
    backendType: "",
    canUseInGrid: false,
  },

  {
    typeName: "emptySpace",
    icon: ["fas", "border-none"],
    type: InputTypes.emptySpace,
    backendType: "",
    canUseInGrid: false,
  },

  {
    typeName: "attachment",
    icon: ["fa", "fa-paperclip"],
    type: InputTypes.attachment,
    backendType: "",
    canUseInGrid: false,
  },
      {
    typeName: "items",
    icon: ["fa", "boxes-stacked"],
    type: InputTypes.items,
    backendType: "string",
    canUseInGrid: true,
  },
  // {
  //     typeName:'Step',
  //     icon:["fas", 'object-ungroup'],
  //     type:InputTypes.Step,
  //     backendType:"",
  //     canUseInGrid:false,
  // },
  {
    typeName: "Card",
    icon: ["far", "fa-square"],
    type: InputTypes.card,
    backendType: "",
    canUseInGrid: false,
  },


  // {
  //     typeName:'simpleGrid',
  //     icon:["fas", 'table'],
  //     type:InputTypes.simpleGrid,
  //     backendType:"",
  //     canUseInGrid:false,
  // }
  // {
  //     typeName:'label',
  //     icon:["fas", "heading"],
  //     type:InputTypes.label,
  //     backendType:"",
  // }
];
export const DictionaryAvailable = [
  {
    typeName: "Person",
    type: InputTypes.text,
    backendType: "guid",
  },
  {
    typeName: "Position",
    type: InputTypes.text,
    backendType: "guid",
  },
  {
    typeName: "Sex",
    type: InputTypes.dropDown,
    backendType: "int",
  },
];
